import EntityType from '@/shared/enums/EntityType';

const activityDimension = {
  id: `${EntityType.ACTIVITY}`,
  label: 'Activity',
  order: [EntityType.ACTIVITY],
};

const organisationDimensions = [
  {
    id: `${EntityType.MANAGER}:${EntityType.GROUP}:${EntityType.ROLE}:${EntityType.PERSON}`,
    label: 'Span > Manager > Team > Role > Person',
    order: [
      EntityType.LAYER,
      EntityType.SPAN,
      EntityType.MANAGER,
      EntityType.GROUP,
      EntityType.ROLE,
      EntityType.PERSON,
    ],
  },
  {
    id: `${EntityType.Manager}:${EntityType.ROLE}:${EntityType.GROUP}:${EntityType.PERSON}`,
    label: 'Span > Manager > Role > Team > Person',
    order: [
      EntityType.LAYER,
      EntityType.SPAN,
      EntityType.MANAGER,
      EntityType.ROLE,
      EntityType.GROUP,
      EntityType.PERSON,
    ],
  },
  {
    id: `${EntityType.MANAGER}:${EntityType.ROLE}:${EntityType.PERSON}:${EntityType.GROUP}`,
    label: 'Span > Manager > Role > Person > Team',
    order: [
      EntityType.LAYER,
      EntityType.SPAN,
      EntityType.MANAGER,
      EntityType.ROLE,
      EntityType.PERSON,
      EntityType.GROUP,
    ],
  },
];

const roleDimensions = [
  {
    id: `${EntityType.ROLE}`,
    label: 'Span > Role',
    order: [EntityType.LAYER, EntityType.SPAN, EntityType.ROLE],
  },
];

const SpanDimensions = {
  [EntityType.ACTIVITY]: activityDimension,
  [EntityType.GROUP]: organisationDimensions,
  [EntityType.MANAGER]: organisationDimensions,
  [EntityType.ORGANISATION]: organisationDimensions,
  [EntityType.ROLE]: roleDimensions,
};

export default SpanDimensions;
